import {
  BasicCheckbox,
  BasicCheckboxGroup
} from '@vmware-react/clarity/dist/basic-inputs';
import React from 'react';
import { DCheckboxField, DCheckboxValue } from './types';

interface Props {
  field: DCheckboxField;
  value: DCheckboxValue;
  error?: string;
  touched?: boolean;
  hidden?: boolean;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleBlur: (event: React.FocusEvent<HTMLInputElement>) => void;
}

export default (props: Props) => {
  const { field, error, touched, hidden, value, handleChange, handleBlur } =
    props;
  const hasError = typeof error === 'string' && error.length > 0;
  const type = field.type as 'checkbox' | 'toggle';
  return (
    <>
      {field.options ? (
        <BasicCheckboxGroup
          label={field.label}
          required={field.required}
          hidden={hidden}
          error={hasError && touched}
          inline={field.inline}
          disabled={field.disabled}
          errorMessage={error}
          helpText={field.helperText}
          helpTextPosition={field.helperTextPosition}
          helperTextToolTipConfig={field.helperTextToolTipConfig}>
          {field.options.map(option => {
            const checked =
              typeof value === 'boolean' ? value : value[option.key];
            return (
              <BasicCheckbox
                key={option.key}
                type={type}
                name={`${field.name}.${option.key}`}
                checked={checked}
                label={option.textLabel}
                onChange={handleChange}
                onBlur={handleBlur}
                disabled={field.disabled}
              />
            );
          })}
        </BasicCheckboxGroup>
      ) : (
        <BasicCheckboxGroup
          label={field.label}
          required={field.required}
          error={hasError && touched}
          inline={field.inline}
          hidden={hidden}
          disabled={field.disabled}
          errorMessage={error}
          helpText={field.helperText}
          helpTextPosition={field.helperTextPosition}
          helperTextToolTipConfig={field.helperTextToolTipConfig}>
          <BasicCheckbox
            name={`${field.name}`}
            type={type}
            checked={value as boolean}
            label={field.textLabel}
            onChange={handleChange}
            onBlur={handleBlur}
            disabled={field.disabled}
            attrs={field.attrs}
          />
        </BasicCheckboxGroup>
      )}
    </>
  );
};
